import Pill from '@aboutyou/legacy-shared/src/ui/Drops/components/Pill/Pill'
import React, { FC, RefObject } from 'react'
import { Sticky } from 'react-stickup-ay'
import styled, { css } from 'styled-components'
import { inactiveColor } from 'uiComponents/constants/colors'
import { fwHeavy } from 'uiComponents/constants/typography'

export const DropDetailsCountdown: FC<{
  dropDetailsWrapperRef: RefObject<HTMLDivElement>
  text: string
  isPastDrop: boolean
}> = ({ dropDetailsWrapperRef, text, isPastDrop }) => {
  return (
    <StyledSticky container={dropDetailsWrapperRef}>
      <StyledCountDownPill type="main" isPastDrop={isPastDrop}>
        {text}
      </StyledCountDownPill>
    </StyledSticky>
  )
}

const StyledSticky = styled(Sticky)`
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 1;
`

const StyledCountDownPill = styled(Pill)<{ isPastDrop: boolean }>`
  position: absolute;
  left: 0;
  right: 0;
  width: 260px;
  margin: 0 auto;
  ${fwHeavy};
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  ${({ isPastDrop }: { isPastDrop: boolean }) =>
    isPastDrop &&
    css`
      max-width: 145px;
      background-color: ${inactiveColor};
    `}
`
